export class roomDTO {
    constructor(
        isSafari: number
    ){}
}